import { ConfigProvider } from 'antd';
import React, { useMemo, useState } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';

import { getAntdThemeConfig } from 'utils/color/antdTheme';
import { type HorizonTheme, Theme, Themes, ThemeStorageKey } from 'utils/color/horizonTheme';
import { getItem as getStorageItem, setItem as setStorageItem } from 'utils/storage';

export const ThemeProvider: React.FC<{ theme: Omit<HorizonTheme, 'onChange'> }> = ({
  children,
  ...props
}) => {
  const [currentThemeName, setCurrentThemeName] = useState<Theme>(
    (getStorageItem(ThemeStorageKey) ?? Theme.Light) as Theme
  );

  // Memoized: a new theme object is a context change for every antd component in the app.
  const antdTheme = useMemo(() => getAntdThemeConfig(Themes[currentThemeName]), [currentThemeName]);

  const handleChange = (themeName: Theme) => {
    setCurrentThemeName(themeName);
    setStorageItem(ThemeStorageKey, themeName);
  };

  return (
    <StyledComponentsThemeProvider
      {...props}
      theme={{
        ...Themes[currentThemeName],
        onChange: handleChange,
      }}
    >
      <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>
    </StyledComponentsThemeProvider>
  );
};
